import { Box, Body } from '@hover/blueprint';
import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

interface Props {
  visible: boolean;
}

const FirstTeamValue: React.FC<Props> = ({ visible }) => (
  <Box
    display={visible ? 'block' : 'none'}
    width={{ base: '100%', desktop: 584 }}
  >
    <StaticImage
      quality={100}
      placeholder="blurred"
      src="../../../assets/images/our_values_1.png"
      alt="our values 1"
    />
    <Body mt={600} mb={{ desktop: 900 }} size={500} maxW="584px">
      We think critically, share different perspectives openly, question
      assumptions freely, and push each other every chance we get.
    </Body>
  </Box>
);

export default FirstTeamValue;
